import {Injectable} from '@angular/core';
import {HttpClient, HttpResponse} from '@angular/common/http';
import {Observable} from 'rxjs';
import {map} from 'rxjs/internal/operators';
import * as moment from 'moment';
import {SERVER_API_URL} from "../app.constants";
import {ISettingPackage} from "../shared/model/settingPackage.model";
import {createRequestOption} from "../shared/util/request-util";


type EntityResponseType = HttpResponse<ISettingPackage>;
type EntityArrayResponseType = HttpResponse<ISettingPackage[]>;

@Injectable({providedIn: 'root'})
export class SettingPackageService {
  public resourceUrl = SERVER_API_URL + 'api/setting-package';

  constructor(protected http: HttpClient) {
  }

  create(contract: ISettingPackage): Observable<EntityResponseType> {
    const copy = this.convertDateFromClient(contract);
    return this.http
      .post<ISettingPackage>(this.resourceUrl, copy, {observe: 'response'})
      .pipe(map((res: EntityResponseType) => this.convertDateFromServer(res)));
  }

  update(contract: ISettingPackage): Observable<EntityResponseType> {
    const copy = this.convertDateFromClient(contract);
    return this.http
      .put<ISettingPackage>(this.resourceUrl, copy, {observe: 'response'})
      .pipe(map((res: EntityResponseType) => this.convertDateFromServer(res)));
  }

  find(id: number): Observable<EntityResponseType> {
    return this.http
      .get<ISettingPackage>(`${this.resourceUrl}/${id}`, {observe: 'response'})
      .pipe(map((res: EntityResponseType) => this.convertDateFromServer(res)));
  }

  query(req?: any): Observable<EntityArrayResponseType> {
    const options = createRequestOption(req);
    return this.http
      .get<ISettingPackage[]>(this.resourceUrl, {params: options, observe: 'response'})
      .pipe(map((res: EntityArrayResponseType) => this.convertDateArrayFromServer(res)));
  }

  findMyContractCount(id: number): Observable<HttpResponse<any>> {
    return this.http
      .get<any>(`${this.resourceUrl + '-self-count'}/${id}`, {observe: 'response'});
  }

  findMyContract(id: number): Observable<EntityArrayResponseType> {
    // const options = createRequestOption(req);
    return this.http
      .get<ISettingPackage[]>(`${this.resourceUrl + '-self'}/${id}`, {observe: 'response'})
      .pipe(map((res: EntityArrayResponseType) => this.convertDateArrayFromServer(res)));
  }

  findContractTransaction(id: number): Observable<EntityArrayResponseType> {
    // const options = createRequestOption(req);
    return this.http
      .get<ISettingPackage[]>(`${this.resourceUrl + '-transaction'}/${id}`, {observe: 'response'})
      .pipe(map((res: EntityArrayResponseType) => this.convertDateArrayFromServer(res)));
  }
  findWithCustomerId(id: number): Observable<EntityArrayResponseType> {
    // const options = createRequestOption(req);
    return this.http
      .get<ISettingPackage[]>(`${this.resourceUrl + '-customer'}/${id}`, {observe: 'response'})
      .pipe(map((res: EntityArrayResponseType) => this.convertDateArrayFromServer(res)));
  }

  delete(id: number): Observable<HttpResponse<any>> {
    return this.http.delete<any>(`${this.resourceUrl}/${id}`, {observe: 'response'});
  }

  protected convertDateFromClient(contract: ISettingPackage): ISettingPackage {
    const copy: ISettingPackage = Object.assign({}, contract, {
      // expiratioDate: contract.expiratioDate != null && contract.expiratioDate.isValid() ? contract.expiratioDate.format(DATE_FORMAT) : null
    });
    return copy;
  }

  protected convertDateFromServer(res: EntityResponseType): EntityResponseType {
    if (res.body) {
      // res.body.expiratioDate = res.body.expiratioDate != null ? moment(res.body.expiratioDate) : null;
    }
    return res;
  }

  protected convertDateArrayFromServer(res: EntityArrayResponseType): EntityArrayResponseType {
    if (res.body) {
      res.body.forEach((contract: ISettingPackage) => {
        // contract.expiratioDate = contract.expiratioDate != null ? moment(contract.expiratioDate) : null;
      });
    }
    return res;
  }
}
